import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const COOKIE_NOTICE_KEY = "creavideos-cookie-notice-dismissed";

export default function CookieNotice() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = window.localStorage.getItem(COOKIE_NOTICE_KEY);
    setIsVisible(dismissed !== "true");
  }, []);

  const handleDismiss = () => {
    window.localStorage.setItem(COOKIE_NOTICE_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-4 bottom-4 z-50 mx-auto max-w-2xl rounded-xl border border-slate-200 bg-white/95 p-4 shadow-lg backdrop-blur-sm sm:inset-x-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <p className="text-sm leading-6 text-slate-700 sm:pr-4">
          CreaVideos uses only cookies and similar technologies that are strictly
          necessary for the website to function, including login, secure payments,
          and social media sharing of videos you choose to publish. We do not
          currently use analytics or marketing cookies.
        </p>

        <div className="flex shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={handleDismiss}
            className="inline-flex items-center justify-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-slate-800"
          >
            OK
          </button>
          <Link
            to="/privacy-policy"
            className="inline-flex items-center justify-center rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50"
          >
            Learn more
          </Link>
        </div>
      </div>
    </div>
  );
}
